<template>
  <div id="SBRenewalPopup" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header cancelModal-bgcolor">
          <button type="button" class="close" @click="closePopup">&times;</button>
          <p class="header-title">Renewal Request</p>
          <hr class="m-0" />
        </div>
        <div class="modal-body row m-0">
          <template v-if="body_text === 'default'">
            <p class="col-xs-12 service-name text-color-blue">{{ selectedService.name }}</p>
            <div class="col-xs-12 mb-20 list-container">
              <div
                class="col-xs-12 col-sm-offset-1 col-sm-10 services-list p-0 align-left"
                v-for="(project, index) in projectsList"
                :key="index"
              >
                <span class="col-xs-1 p-0">
                  <span class="checkbox inline-checkbox">
                    <label>
                      <input type="checkbox" v-model="selectedProjects" :value="project.id" />
                      <span class="cr">
                      </span>
                    </label>
                  </span>
                </span>
                <span class="col-xs-6 p-0">{{ project.name }} </span>
                <span class="col-xs-5 align-right pr-0">
                  {{ getExpiryStatus(project.expiresAt) }} on
                  {{ project.expiresAt | dateFilter }}</span
                >
              </div>
            </div>
            <p class="col-xs-12 disclaimary-text mt-20">
              Renew to maintain edit access to your project for another year.
            </p>
            <button
              class="btn emergo-blue-button mt-10 mb-10"
              @click="submitRequest()"
              :disabled="!selectedProjects.length"
            >
              Submit Renewal Request
            </button>
          </template>
          <template v-else>
            <div class="p-confirm">
              <img
                src="/static/images/icons/endtour_checkbox.svg"
                class="success-img"
                alt="endtour-icon"
              />
              <p class="confirm_title">Success</p>
              <div class="mb-10">Thank you for your renewal request.</div>
              <div>Our Sales Team will contact you soon.</div>
              <button class="btn emergo-blue-button mt-25 mb-10 wd-180" @click="closePopup()">
                OK
              </button>
            </div>
          </template>
        </div>
      </div>
      <loader :loadingStatus="loaderStatus"></loader>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import moment from 'moment';
import { submitSBRenewalRequest } from '../../apis/submissionBuilder';
import Loader from '../UIComponents/Loader.vue';

export default {
  props: ['selectedService', 'projectsList'],
  components: { Loader },
  data() {
    return {
      body_text: 'default',
      loaderStatus: false,
      selectedProjects: []
    };
  },
  filters: {
    dateFilter(date) {
      if (date) return moment(date).format('DD MMM YYYY');
      return '';
    }
  },
  methods: {
    getExpiryStatus(date) {
      if (date) return moment(date).isBefore(moment(), 'day') ? 'Expired' : 'Expires';
      return false;
    },
    closePopup() {
      $('#SBRenewalPopup').modal('hide');
    },
    async submitRequest() {
      this.loaderStatus = true;
      const response = await submitSBRenewalRequest({
        data: { project_ids: this.selectedProjects }
      });
      this.loaderStatus = false;
      if (response && !response.errorMessage) {
        this.body_text = 'submited';
      } else {
        this.$notify({
          clear: true,
          group: 'custom-notification'
        });
        this.$notify({
          type: 'error',
          title: 'Renewal Request',
          text: 'Unable to send renewal request.',
          group: 'custom-notification'
        });
      }
    }
  },
  mounted() {
    $('#SBRenewalPopup').on('hidden.bs.modal', () => {
      this.body_text = 'default';
      this.selectedProjects = [];
    });
  }
};
</script>
<style lang="scss" scoped>
.modal-header {
  .close {
    background: none;
    opacity: 0.5;
    height: 17px;
    color: $deep-gray !important;
    width: 17px;
    border-radius: $radius20;
    outline: none;
    @include fontItems($font-32, 17px, $font-weight-small);
  }
  &.cancelModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    text-align: center;
    padding-bottom: 0;
  }
  .header-title {
    @include fontItems($font-24, 28px, $font-weight-small);
    outline: none;
    font-family: Roboto;
    color: $dark-black-alpha;
    margin: 10px 0 15px 0;
  }
}
.modal-content,
.modal-header.cancelModal-bgcolor {
  border-radius: $radius10;
}
.modal-body {
  text-align: center;
  .service-name {
    @include fontItems($font-32, 28px, $font-weight-medium);
    outline: none;
    font-family: Roboto;
    margin-bottom: 25px;
  }
}
.list-container {
  max-height: 150px;
  overflow-y: auto;
}
.services-list {
  margin-top: 7px;
  color: $dark-black-alpha;
  font-size: $font-14;
  border-bottom: 1px solid $light-gray;
}
.disclaimary-text {
  color: $deep-gray;
  font-size: $font-14;
  line-height: 18px;
}
.disclaimary-warning {
  color: $deep-gray;
  font-size: $font-12;
  line-height: 18px;
}
.btn {
  padding: 6px 30px;
}
.check_img {
  width: 50px;
  background: $light-green;
  padding: 6px;
  border-radius: 50px;
  height: 50px;
}
.p-confirm {
  font-family: roboto;
  font-weight: normal;
  font-size: $font-20;
  line-height: 24px;
  text-align: center;
  color: $dark-black-alpha;
}
.wd-180 {
  width: 180px;
}
.confirm_title {
  color: $primary;
  margin: 15px 0px 20px 0px;
  font-weight: $font-weight-medium;
  font-family: roboto;
  font-size: $font-32;
  line-height: 37px;
}
.success-img {
  width: 90px;
  height: 90px;
}
</style>
